export const cambiaUfficio = ufficio => dispatch => dispatch({ type: 'CAMBIA_UFFICIO', ufficio });

export const attivaTour730 = () => dispatch => dispatch({ type: 'ATTIVA_TOUR_730' });

export const disattivaTour730 = () => dispatch => dispatch({ type: 'DISATTIVA_TOUR_730' });

export const attivaTourRichiesteEnti = () => dispatch => dispatch({ type: 'ATTIVA_TOUR_RICHIESTEENTI' });

export const disattivaTourRichiesteEnti = () => dispatch => dispatch({ type: 'DISATTIVA_TOUR_RICHIESTEENTI' });

export const attivaTourImu = () => dispatch => dispatch({ type: 'ATTIVA_TOUR_IMU' });

export const disattivaTourImu = () => dispatch => dispatch({ type: 'DISATTIVA_TOUR_IMU' });
